var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSubSuccessWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 32C11.25 32 6 29 3.125 24C0.25 19.0625 0.25 13 3.125 8C6 3.0625 11.25 0 17 0C22.6875 0 27.9375 3.0625 30.8125 8C33.6875 13 33.6875 19.0625 30.8125 24C27.9375 29 22.6875 32 17 32ZM24.0625 13.0625H24C24.625 12.5 24.625 11.5625 24 10.9375C23.4375 10.375 22.5 10.375 21.9375 10.9375L15 17.9375L12.0625 15C11.4375 14.375 10.5 14.375 9.9375 15C9.3125 15.5625 9.3125 16.5 9.9375 17.0625L13.9375 21.0625C14.5 21.6875 15.4375 21.6875 16.0625 21.0625L24.0625 13.0625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubSuccessWhite);
export default __webpack_public_path__ + "static/media/icon-sub-success-white.0f9103d20d98df929aaee84acbe94ff6.svg";
export { ForwardRef as ReactComponent };